import React from 'react';
import { ChevronLeft } from 'lucide-react';

interface AudioRecordingHintProps {
  isPreparing: boolean;
  isLockedMode: boolean;
  holdProgress: number;
  translateX: number;
}

/** Preparation stays visible for both a held mic and a locked recording. */
const AudioRecordingHint: React.FC<AudioRecordingHintProps> = ({ isPreparing, isLockedMode, holdProgress, translateX }) => (
  <div className="flex min-w-0 flex-1 items-center justify-center pointer-events-none">
    <div role="status" aria-live="polite" aria-atomic="true"
      className={`items-center gap-0.5 font-semibold text-[10px] sm:text-xs uppercase whitespace-nowrap ${isLockedMode && !isPreparing ? 'hidden min-[400px]:flex' : 'flex'}`}
      style={{ opacity: holdProgress, transform: translateX ? `translateX(${translateX / 4}px)` : undefined }}>
      {!isPreparing && <ChevronLeft size={14} aria-hidden="true" className="text-danger animate-pulse motion-reduce:animate-none" />}
      <span className={isPreparing ? 'text-muted font-bold' : isLockedMode ? 'text-danger font-bold' : 'shimmer-text font-bold'}>
        {isPreparing ? 'Preparando micro' : isLockedMode ? 'Papelera para cancelar' : 'Desliza para cancelar'}
      </span>
    </div>
  </div>
);

export default AudioRecordingHint;
